import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const GitFlowBaseUrl = 'http://127.0.0.1:8002/api/1.0/flow/gitflow/'
// 持续发布基础URL
const baseDeployUrl = config.baseDeployUrl
const GitFlowBaseUrl = baseDeployUrl + '/api/1.0/flow/gitflow/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getList = (params) => {
  return axios.request({
    url: GitFlowBaseUrl + 'list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const saveGitFlow = (data) => {
  return axios.request({
    url: GitFlowBaseUrl + 'create',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const getGitFlowDetail = (params) => {
  return axios.request({
    url: GitFlowBaseUrl + params.id,
    headers: baseHeaders,
    method: 'get'
  })
}

export const mergeGitFlow = (id) => {
  return axios.request({
    url: GitFlowBaseUrl + id + '/merge_request',
    headers: baseHeaders,
    method: 'post'
  })
}

export const buildGitFlow = (id, scene) => {
  return axios.request({
    url: GitFlowBaseUrl + id + '/build/' + scene,
    headers: baseHeaders,
    params: {
      async: true
    },
    method: 'get'
  })
}

export const rollbackGitFlow = (id, scene, commit) => {
  return axios.request({
    url: GitFlowBaseUrl + id + '/rollback/' + scene + '/' + commit,
    headers: baseHeaders,
    params: {
      async: true
    },
    method: 'get'
  })
}

export const cancelGitFlow = (id) => {
  return axios.request({
    url: GitFlowBaseUrl + id,
    headers: baseHeaders,
    method: 'delete'
  })
}

export const fetchRollbackCommitsList = (value) => {
  return axios.request({
    url: GitFlowBaseUrl + value + '/rollback/commits',
    headers: baseHeaders,
    method: 'get'
  })
}
